import { Config, Layout } from '../../../LineChart';

export const LAYOUT: Partial<Layout> = {
  showLegend: false,
};

export const CONFIG: Partial<Config> = {
  scrollZoom: false,
  selectionZoom: false,
  buttonZoom: false,
  pan: false,
};
